import { watch } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useRouter } from 'vue-router'
import { QueryKey } from '../constants/queryKeys'
import { APIS, SERVICES } from 'src/config/constants'
import { axiosInstance } from 'src/utils/request'
import { useAppStore } from 'src/stores'

export const APP_VERSION = 1

export function useSupportedVersionCheck() {
  const router = useRouter()
  const appStore = useAppStore()

  const queryKey = [QueryKey.SupportedVersions]

  const { data } = useQuery({
    queryKey,
    queryFn: async () => {
      const res = await axiosInstance.get(
        `${SERVICES.res}/${APIS.public}/${APIS.supportedVersions}`,
      )

      return res.data
    },
    refetchInterval: 15 * 60 * 1000, // every 15 minutes
  })

  watch(
    () => data.value,
    () => {
      appStore.setMinimumSupportedAppVersion(
        data.value?.minimumSupportedVersion,
      )
      if (data.value && APP_VERSION < data.value.minimumSupportedVersion) {
        void router.push({ name: 'outdatedVersion' })
      }
    },
  )
}
